import apiClient from "@/api/apiClient";

export const getWarranties = async (params) => {
  const result = await apiClient.get("/api/warranties", { params });
  return result.data;
};

export const getWarranty = async (id) => {
  const result = await apiClient.get(`/api/warranties/${id}`);
  return result.data;
};

export const updateWarranty = async (id, data) => {
  const result = await apiClient.patch(`/api/warranties/${id}`, data);
  return result.data;
};

export const activateWarranty = async (id, purchaseDate) => {
  const result = await apiClient.post(`/api/warranties/${id}/activate`, {
    purchase_date: purchaseDate || null,
  });
  return result.data;
};

export const deactivateWarranty = async (id, code) => {
  const result = await apiClient.post(`/api/warranties/${id}/deactivate`, { code });
  return result.data;
};

export const rejectWarranty = async (id, reason) => {
  const result = await apiClient.post(`/api/warranties/${id}/reject`, { reason });
  return result.data;
};

export const uploadWarrantyFile = async (id, file) => {
  const form = new FormData();
  form.append("file", file);
  const result = await apiClient.post(`/api/warranties/${id}/files`, form);
  return result.data;
};
